import { getUserType, signInApi, signUpApi } from '../../api/SignIn/signIn.api';
import { getProfile } from '../profile/action';
import {
	SIGN_IN_FAIL,
	SIGN_IN_START,
	SIGN_IN_SUCCESS,
	SET_REDIRECT,
	ClEAR_ERROR,
} from './types';

export const signInWithEmail = (email, password, check) => {
	return async (dispatch) => {
		try {
			dispatch(signInStart());
			const userInfo = await signInApi(email, password, check);
			const userType = await getUserType();
			dispatch(signInSuccess({ userInfo, userType }));
			getProfile();
		} catch (error) {
			dispatch(signInFail(error));
		}
	};
};

export const signUpWithEmail = (email, password, fullName, telNumber) => {
	return async (dispatch) => {
		try {
			await dispatch(signInStart());
			const userInfo = await signUpApi(
				email,
				password,
				fullName,
				telNumber
			);
			await dispatch(signInSuccess({ userInfo, userType: 'client' }));
		} catch (error) {
			await dispatch(signInFail(error));
		}
	};
};

const signInStart = () => ({
	type: SIGN_IN_START,
});

export const signInSuccess = (payload) => ({
	type: SIGN_IN_SUCCESS,
	payload,
});

const signInFail = (payload) => ({
	type: SIGN_IN_FAIL,
	payload,
});

export const setRedirect = (payload) => ({
	type: SET_REDIRECT,
	payload,
});

export const clearError = () => ({
	type: ClEAR_ERROR,
});